import React from "react";
import { useState } from "react";
import Booking from "../../pages/Booking"

export default function Calendar() {
    const [ openState, setOpenState ] = useState({
        isOpen: false
    });
    function showBooking() {
        setOpenState( state => ({
            isOpen: !state.isOpen
        }))
    };

    return (
        <section id="calendar">
            <div class="text-block">
                <h2>Book a Session</h2>
                <p>To book a virtual, in studio, or travel session with Brittney, please email <a href="mailto:booking@eskewconsulting.com">booking@eskewconsulting.com</a>.</p>
                <p>To book with any other team member, please click Book a Session below.</p>
                <button onClick={()=> showBooking()} className="cta transition">Book a session</button>
                <p>If you have any additional questions regarding our services, our coaches, or anything in between, please email <a href="mailto:info@eskewstudios.com">info@eskewstudios.com</a>.</p>

            </div>
            <Booking className={openState.isOpen ? "book-now" : ""}/>
            
        </section>
    )
}